module.exports = __webpack_public_path__ + "media/images/homepage/slider4-ae34530b918da9634adf98b217cfb579.png";